import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCategories } from "../../redux/Slices/CategorySlice";
import { GetAllBrands } from "../../redux/Slices/BrandsSlice";

const UseSideBarFilter = (searchProductsFunc) => {
    const limit = 20
    const dispatch = useDispatch();
    const [AllCategoriesLoading, setAllCategoriesLoading] = useState(true)
    const [AllBrandsLoading, setAllBrandsLoading] = useState(true)
    const [AllCategoriesData, setAllCategoriesData] = useState([])
    const [CategoryListArray, setCategoryListArray] = useState([])
    const [BrandListArray, setBrandListArray] = useState([])
    const [AllBrandsData, setAllBrandsData] = useState([])
    const [CategoryChecked, setCategoryChecked] = useState([])
    const [BrandChecked, setBrandChecked] = useState([])
    const [Price_From, setPriceFrom] = useState("")
    const [Price_To, setPriceTo] = useState("")
    const { AllCategories } = useSelector(state => state.CategoryReducer)
    const { AllBrands } = useSelector(state => state.BrandsReducer)
    // handle get all categories
    const handleGetAllCategories = async () => {
        setAllCategoriesLoading(true)
        await dispatch(GetAllCategories(`limit=${limit}`));
        setAllCategoriesLoading(false)
    }

    // handle all categories request response
    useEffect(() => {
        if (AllCategoriesLoading === false) {
            if (AllCategories && AllCategories.data) {
                setAllCategoriesData(AllCategories.data)
            }
        }
    }, [AllCategoriesLoading])


    // handle get all brands
    const handleGetAllBrands = async () => {
        setAllBrandsLoading(true)
        await dispatch(GetAllBrands(`limit=${limit}`));
        setAllBrandsLoading(false)
    }

    // handle all brands request response
    useEffect(() => {
        if (AllBrandsLoading === false) {
            if (AllBrands && AllBrands.data) {
                setAllBrandsData(AllBrands.data)
            }
        }
    }, [AllBrandsLoading])

    // run the get all categories & get all brands function
    useEffect(() => {
        handleGetAllCategories()
        handleGetAllBrands()
    }, []);


    // handle change category value
    const handleCategoryChecked = (e) => {
        let value = 0
        value = e.target.value
        if (value === "0") {
            if (e.target.checked) {
                setCategoryListArray([]);
                setCategoryChecked([]);
                localStorage.setItem("categoriesChecked", [])
                localStorage.setItem("CategoryArray", []);
            }
        } else {
            if (e.target.checked) {
                setCategoryListArray([...CategoryChecked, value])
                setCategoryChecked([...CategoryChecked, value])
            } else {
                const newArray = CategoryChecked.filter((e) => e !== value)
                setCategoryChecked(newArray)
                setCategoryListArray(newArray)
            }
        }
    }

    // run search function by category value
    useEffect(() => {
        if (CategoryChecked.length >= 1) {
            setCategoryListArray(localStorage.setItem("CategoryArray", CategoryChecked))
            let categoriesValue = CategoryChecked.map(item => `category[in][]=${item}&`).join('');
            localStorage.setItem("categoriesChecked", categoriesValue)
            searchProductsFunc()
        } else {
            searchProductsFunc()
        }
    }, [CategoryChecked])

    // handleBrandChecked
    const handleBrandChecked = (e) => {
        let value = 0;
        value = e.target.value;
        if (value === "0") {
            if (e.target.checked) {
                setBrandListArray([])
                setBrandChecked([])
                localStorage.setItem("BrandChecked", [])
                localStorage.setItem("BrandArray", []);
            }
        } else {
            if (e.target.checked === true) {
                setBrandChecked([...BrandChecked, value])
                setBrandListArray([...BrandChecked, value])
            } else {
                const newArray = BrandChecked.filter((e) => e !== value)
                setBrandChecked(newArray)
                setBrandListArray(newArray)
            }
        }
    }

    // run the handle brand checked
    useEffect(() => {
        if (BrandChecked.length >= 1) {
            setBrandListArray(localStorage.setItem("BrandArray", BrandChecked))
            let BrandsValue = BrandChecked.map(item => `brand[in][]=${item}`)
            localStorage.setItem("BrandChecked", BrandsValue)
            searchProductsFunc()
        } else {
            searchProductsFunc()
        }
    }, [BrandChecked])

    // handlePriceFrom
    const HandlePriceFrom = (e) => {
        setPriceFrom(e.target.value)
        localStorage.setItem("priceFrom", e.target.value)
    }

    // handle price to 
    const HandlePriceTo = (e) => {
        setPriceTo(e.target.value)
        localStorage.setItem("priceTo", e.target.value)
    }

    // handle Price Filter
    const handlePriceFilter = () => {
        searchProductsFunc()
    }


    // useEffect to run searchProductsFunc() to refresh component when orice changed
    useEffect(() => {
        if (localStorage.getItem("priceTo") && localStorage.getItem("priceFrom") === null) {
            searchProductsFunc()
        } else {
            searchProductsFunc()
        }
    }, [Price_From, Price_To])

    return [Price_From, Price_To, handlePriceFilter, CategoryListArray, AllCategoriesData, AllBrandsData, handleCategoryChecked, handleBrandChecked, HandlePriceFrom, HandlePriceTo]
};

export default UseSideBarFilter;